import React from 'react';
import { Facebook } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[rgb(var(--text-primary))] py-12" style={{ color: '#FFFFFF' }}>
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-8">
          {/* Brand Column */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center">
                <img
                  src="https://customer-assets.emergentagent.com/job_661426c8-676a-4387-8d77-4e9e1aa6a517/artifacts/1a2m54ip_Logo%20OH%20%26%20Asociados.png"
                  alt="Ochoa Herrera & Asociados"
                  className="w-full h-full object-contain"
                />
              </div>
              <span className="text-lg font-semibold font-['Crimson_Text']" style={{ color: '#FFFFFF' }}>
                Ochoa Herrera & Asociados
              </span>
            </div>
            <p className="body-small leading-relaxed" style={{ color: '#FFFFFF' }}>
              Despacho jurídico en Cuernavaca con más de 11 años de experiencia, 
              brindando acompañamiento legal con enfoque humanista.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="heading-3 mb-4" style={{ color: '#FFFFFF' }}>Enlaces Rápidos</h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="#servicios"
                  className="body-small transition-colors"
                  style={{ color: '#FFFFFF' }}
                >
                  Áreas de Práctica
                </a>
              </li>
              <li>
                <a
                  href="#nosotros"
                  className="body-small transition-colors"
                  style={{ color: '#FFFFFF' }}
                >
                  Nosotros
                </a>
              </li>
              <li>
                <a
                  href="#faq"
                  className="body-small transition-colors"
                  style={{ color: '#FFFFFF' }}
                >
                  Preguntas Frecuentes
                </a>
              </li>
              <li>
                <a
                  href="#contacto"
                  className="body-small transition-colors"
                  style={{ color: '#FFFFFF' }}
                >
                  Contacto
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="heading-3 mb-4" style={{ color: '#FFFFFF' }}>Contacto</h3>
            <ul className="space-y-2">
              <li className="body-small" style={{ color: '#FFFFFF' }}>
                Fray Bartolomé de las Casas 17, Despacho 8C
              </li>
              <li className="body-small" style={{ color: '#FFFFFF' }}>
                Col. Centro, Cuernavaca, Morelos
              </li>
              <li className="body-small" style={{ color: '#FFFFFF' }}>
                C.P. 62000
              </li>
              <li className="body-small mt-3" style={{ color: '#FFFFFF' }}>
                Tel: 777 149 5537
              </li>
              <li className="body-small" style={{ color: '#FFFFFF' }}>
                contacto@ochoaherrerayasociados.com
              </li>
            </ul>

            {/* Social Media - Only Facebook */}
            <div className="flex items-center gap-4 mt-6">
              <a
                href="https://www.facebook.com/share/1Dvpp3gffj/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-[rgb(var(--burgundy-primary))] transition-colors flex items-center justify-center"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" style={{ color: '#FFFFFF' }} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-center items-center gap-4">
            <p className="body-small" style={{ color: '#FFFFFF' }}>
              © {currentYear} Ochoa Herrera & Asociados. Todos los derechos reservados.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
